module.exports = __webpack_public_path__ + "StockImagery2024_Device_Backside_4x5_V4.01eb3f96dd40c6b200826eb6317d296d.jpg";